import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { useFormattedData } from './useFormattedData';

import type { AcceptanceTimeItem } from '@/app/types/Dashboard';

interface Props {
	data: AcceptanceTimeItem[];
	ascending?: boolean;
}

const ChartAcceptanceTime = ({ data = [], ascending = true }: Props) => {
	const sortedData = [...data].sort((a, b) => {
		return ascending ? a.averageTime - b.averageTime : b.averageTime - a.averageTime;
	});

	const options = useFormattedData(sortedData);

	return <HighchartsReact options={options} highcharts={Highcharts} />;
};

export default ChartAcceptanceTime;
